import React from "react";
import styles from "./styles/OutputWindowPayment.module.css";
import { useTranslation } from "react-i18next";
import useNumberFormat from "../../../hooks/useNumberFormat";

/**
 * Payment output window component
 * Used in the side panel to give a preview of the amount going to be paid
 */
const OutputWindowPayment = ({ amount, administrative, currency }) => {
    const { t } = useTranslation();
    const formatNum = useNumberFormat();
    return (
        <div className={`${styles.main_output_container}`}>
            <div className={`${styles.output_container}`}>
                <div className={`${styles.output_amount_label}`}>
                    {t(`amount`)}:
                </div>
                <div
                    className={`${styles.output_amount_value}`}
                >{`${currency}${formatNum(amount)}`}</div>
                <div className={`${styles.output_admin_label}`}>
                    {t(`administrative`)}:
                </div>
                <div
                    className={`${styles.output_admin_value}`}
                >{`${currency}${formatNum(administrative)}`}</div>
                <div className={`${styles.output_total_label}`}>
                    {t(`total amount`)}:
                </div>
                <div
                    className={`${styles.output_total_value}`}
                >{`${currency}${formatNum(administrative + amount)}`}</div>
            </div>
        </div>
    );
};

export default OutputWindowPayment;
